import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=ebe615b6"
import script from "./AreaList.vue?vue&type=script&lang=ts"
export * from "./AreaList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports